/**
 * Configurator Gatsby Browser
 *
 * LanguageContextProvider + GlobalStyles are provided by the landingpage host.
 * No additional browser wrapping needed from the configurator theme.
 *
 * We do capture visitor origin here too: whichever host actually serves a given
 * route (landingpage shell or the configurator build), first-touch attribution
 * is recorded. captureAttribution is idempotent, so running from both is safe.
 */

import { captureAttribution } from 'gatsby-theme-objects/src/utils/attribution';

export const onClientEntry = () => captureAttribution();
export const onRouteUpdate = () => captureAttribution();
